import React from 'react';
import PaidSearchDoubleOptionBarChart from '../PaidSearchDoubleOptionBarChart';
import PaidSearchKeyMetricCards from '../PaidSearchKeyMetricCards';
import AdvertisingMultiMetricTrendChart from '../AdvertisingMultiMetricTrendChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  BEACON_CHART_SPACING,
  BEACON_PRO_PAGE_MARGIN_BOTTOM
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { PaidSearchTopicsGrid } from '../Topics/PaidSearchTopicsGrid';
import { TrafficByTopicBarChart } from '../../TrafficByTopicBarChart';
import { TrafficAdvancedSearchBarChart } from '../../TrafficAdvancedSearchBarChart';
import { useMainEntityType, useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { TrafficNoDataPlaceholder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/pages/NonTopicOrTopicGroupPage';
import { useTrafficAvailability } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/hooks/useTrafficAvailability';
import PaidSearchGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/PaidSearch/PaidSearchGrid';
import { PaidSearchMetricProvider } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/PaidSearch/PaidSearchMetricContext';
import { ExportConfigProvider } from 'src/components/BeaconV2Components/common/AppExportModal/ExportModalContext';

/**
 * Paid search page for non topic views
 */
export function NonTopicOrTopicGroupPage() {
  const mainEntityType = useMainEntityType();
  const { isProductEntity } = useProductEntity();
  const { dataAvailable } = useTrafficAvailability();

  return (
    <ExportConfigProvider overrideShouldIntercept={true}>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING} marginBottom={BEACON_PRO_PAGE_MARGIN_BOTTOM}>
        {dataAvailable ? (
          <>
          <PaidSearchMetricProvider>
            <PaidSearchKeyMetricCards />
            <PaidSearchDoubleOptionBarChart />
            <AdvertisingMultiMetricTrendChart />
          </PaidSearchMetricProvider>
          <TrafficByTopicBarChart metric="paidTraffic" />
          <TrafficAdvancedSearchBarChart metric="adClicks" groupByField="searchTerm" />
          {!['category', 'subcategory', 'product'].includes(mainEntityType) && (
            <TrafficAdvancedSearchBarChart metric="adClicks" groupByField="categoryId" />
          )}
          {!['subcategory', 'product'].includes(mainEntityType) && (
            <TrafficAdvancedSearchBarChart metric="adClicks" groupByField="subCategoryId" />
          )}
          <PercentTotalTrafficSplineChart trafficType="paidTraffic" />
          {isProductEntity ? <PaidSearchGrid /> : <PaidSearchTopicsGrid />}
        </>
      ) : (
          <TrafficNoDataPlaceholder />
        )}
      </Flex>
    </ExportConfigProvider>
  );
}
